import { Injectable } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LoggerService } from '../services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private logger: LoggerService,
  ) {
    this.logger.setName(this.constructor.name);
  }

  canActivate: CanActivateFn = (route, state) => {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      this.authService.logout();
      return false;
    }
  };

  canActivateChild: CanActivateChildFn = (childRoute, state) => {
    return this.canActivate(childRoute, state);
  };
}
